import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import RiskLevelButton from '@components/RiskLevelButton/RiskLevelButton';
import useAdminRiskLevelsByProgramCode from '@store/hooks/useAdminRiskLevelsByProgramCode';

import { IRiskLevelsLegendProps } from './RiskLevelsLegend.interface';

import './style.scss';

const RiskLevelsLegend: FC<IRiskLevelsLegendProps> = ({ programCode }) => {
  const { t } = useTranslation();

  const riskLevels = useAdminRiskLevelsByProgramCode(programCode);

  return (
    <div className="risk-level-legend">
      <div className="risk-level-legend__row">
        <div className="risk-level-legend__name">{t('riskLevels.riskLevelLegend')}</div>
      </div>

      <div className="risk-level-legend__details">
        {riskLevels.map(riskLevel => (
          <div key={riskLevel.id} className="risk-level-legend__panel">
            <div className="risk-level-legend__name">
              <RiskLevelButton
                className="risk-level-legend__risk-level"
                riskLevel={riskLevel}
                showLongName
              />
            </div>
            <div className="risk-level-legend__description">{riskLevel.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskLevelsLegend;
